﻿document.addEventListener("DOMContentLoaded", function () {
  // Select all YouTube iframes
  const youtubeIframes = document.querySelectorAll(
    'iframe[src^="https://www.youtube.com"], iframe[src^="//www.youtube.com"]'
  );

  youtubeIframes.forEach(function (iframe) {
    // Create wrapper div
    const wrapper = document.createElement("div");
    wrapper.className = "embed-responsive embed-responsive-16by9";

    // Insert wrapper before iframe
    iframe.parentNode.insertBefore(wrapper, iframe);

    // Move iframe into wrapper
    wrapper.appendChild(iframe);
  });
});
